const achievements = require("../data/achievement");
const action_types = require("../data/action_types");
const actions = require("../data/actions");
const boxers = require("../data/boxers");
const combos = require("../data/combos");
const punches = require("../data/punches");

exports.getActions = () => {
    return actions;
}

exports.getActionsWithTypes = () => {
    return actions;
}

exports.getCombos = () => {
    let returnCombos = [];

    combos.forEach((combo) => {
        let newCombo = combo;
        let boxer = this.getBoxerByID(combo.boxer);
        newCombo.first_name = boxer.first_name;
        newCombo.last_name = boxer.last_name;
        newCombo.boxer_id = boxer.id;
        newCombo.combo_string = newCombo["combo-array"].toString();
        returnCombos.push(newCombo);
    } )

    return returnCombos;
}

exports.getBoxers = () => {
    return boxers;

}

exports.getBoxerByNickname = (nickname) => {
    let foundBoxer = boxers.find((boxer) => boxer.nickname == nickname);

    if (foundBoxer != undefined)
        return foundBoxer;
    else
        return this.getBoxerByID(nickname);
}

exports.getBoxerByID = (id) => {

    if (id == "common")
    {
        return boxers[0]
    }
        
    else
    {
        return boxers.find((boxer) => boxer.id == id);
    }
        
}